<template>
  <div class="person-center page-content">
    <div class="person-center__header">
      <div class="person-center__header__btns">
        <div class="purches" @click="go('/Wallet')">口袋</div>
        <el-icon size="28" @click="go('/Setting')">
          <svgIcon name="setting" size="22" />
        </el-icon>
      </div>
      <div class="person-center__header__info">
        <!-- 个人头像以及昵称和账号 -->
        <div class="user_info">
          <el-image class="avatar" fit="cover" :src="userInfo.avatar" v-if="userInfo.avatar" />
          <div class="avatar" v-else>
            <svgIcon name="avatar" size="75" />
          </div>
          <div class="name_scope">
            <div class="name">
              {{ userInfo.nickName }}
              <svgIcon name="male" size="20" v-if="userInfo.gender === 0" />
              <svgIcon name="female" size="20" v-if="userInfo.gender === 1" />
            </div>
            <div class="account">
              ID：{{ userInfo.onlyCode }}
              <svgIcon class="copy-icon" name="copy" size="12" @click="copyText(userInfo.onlyCode)" />
            </div>
          </div>
          <div class="user_info__edit" @click="go('/EditProfile')">
            编辑资料
            <svgIcon name="edit_arrow" size="12" />
          </div>
        </div>
        <span class="slogan">{{ userInfo.slogan }}</span>
      </div>
    </div>
    <div class="person-center__market" @click="go('/Shop')">
      <img src="@/assets/images/market_banner.png" />
    </div>
    <div class="person-center__menus">
      <div class="person-center__menus__item" @click="go('/Dynamic')">
        <svgIcon class="menu-icon" name="dynamic" size="25" />
        <span class="title">动态</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
      <div class="person-center__menus__item" @click="go('/Collect')">
        <svgIcon class="menu-icon" name="collect" size="25" />
        <span class="title">收藏</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
      <div class="person-center__menus__item" @click="go('/Shop')">
        <svgIcon class="menu-icon" name="shop" size="25" />
        <span class="title">兑换商城</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
      <div class="person-center__menus__item" @click="go('/RealNameAuth')">
        <img class="menu-icon" src="@/assets/icons/smrz.svg" />
        <span class="title">实名认证</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
      <div class="person-center__menus__item" @click="handleHelpClick">
        <svgIcon class="menu-icon" name="feedback" size="25" />
        <span class="title">客服</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
      <div class="person-center__menus__item" @click="go('/About')">
        <svgIcon class="menu-icon" name="about" size="25" />
        <span class="title">关于</span>
        <svgIcon class="arrow-right" name="arrow_right" size="12" />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { useRouter } from "vue-router";
import { showToast } from "vant";
const router = useRouter();

const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')

const go = (path: string) => {
  if (path === '/Wallet' && userInfo.authentication !== 1) {
    showToast('请先进行实名认证')
    router.push('/RealNameAuth')
  } else {
    router.push(path);
  }
};

const copyText = (text: string) => {
  navigator.clipboard.writeText(text);
  showToast('已复制到剪贴板');
}
</script>
<style lang="scss" scoped>
.person-center {
  width: 100%;
  background-color: #f6f6f6;

  &__header {
    position: relative;
    width: 100%;
    height: 238px;
    color: #fff;
    background: linear-gradient(46deg, #0B6DFF 0%, rgba(4, 16, 246, 0.5) 100%);

    &__btns {
      position: absolute;
      top: 20px;
      right: 20px;
      display: flex;
      align-items: center;

      .purches {
        padding: 4px 14px;
        margin-right: 16px;
        font-size: 13px;
        font-weight: bold;
        color: #764701;
        border-radius: 16px;
        background-image: linear-gradient(45deg, #D3B17D 0%, #FFDEAA 100%);
      }
    }

    &__info {
      position: absolute;
      bottom: 0;
      left: 0;
      padding: 20px;
      box-sizing: border-box;
      width: 100%;

      .user_info {
        display: flex;
        align-items: center;

        .avatar {
          width: 75px;
          height: 75px;
          border-radius: 12px;
          margin-right: 16px;
        }

        .name_scope {
          padding: 4px 0;
          box-sizing: border-box;
          height: 75px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;

          .name {
            font-size: 19px;
            font-weight: bold;
            display: flex;
            align-items: center;
          }

          .account {
            font-size: 13px;
            display: flex;
            align-items: center;

            .copy-icon {
              margin-left: 6px;
            }
          }

        }

        .user_info__edit {
          position: absolute;
          right: 20px;
          font-size: 13px;
          color: #D1D1D1;
          display: flex;
          align-items: center;

          .el-icon {
            margin-left: 2px;
            font-size: 15px;
          }
        }
      }

      .slogan {
        display: block;
        margin-top: 20px;
        font-size: 14px;
        color: #F6F6F6;
      }
    }
  }

  &__market {
    margin: 9px 0;
    padding: 9px 15px;
    box-sizing: border-box;
    width: 100%;
    height: fit-content;

    img {
      width: 100%;
      height: auto;
    }
  }

  &__menus {
    background-color: #fff;

    &__item {
      padding: 13px 16px 13px 15px;
      box-sizing: border-box;
      border-bottom: 1px solid #f6f6f6;
      display: flex;
      align-items: center;

      .menu-icon {
        width: 26px;
        height: 26px;
        margin-right: 16px;
      }

      .title {
        font-size: 15px;
        color: #333;
      }

      .arrow-right {
        position: absolute;
        right: 20px;
      }
    }
  }
}
</style>